"use client";

import { useEffect, useRef } from "react";
import { motion } from "motion/react";
import { scrollToElement } from "../lib/utils";
import chroma from "chroma-js";

function Error({
  className,
  message,
  heavyStyle,
  scrollTo = false,
}: {
  className?: string;
  heavyStyle?: boolean;
  message?: string;
  scrollTo?: boolean;
}) {
  const errorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (message && scrollTo && errorRef.current) {
      scrollToElement(errorRef.current);
    }
  }, [message, scrollTo]);

  const errorBackground = chroma("red")
    .set("hsl.s", 0.63)
    .set("hsl.l", 0.56)
    .hex();

  return !message ? null : (
    <motion.div
      className={`rounded-md ${heavyStyle ? "p-2" : "mt-2 "} ${
        className ? className : ""
      }`}
      style={{ backgroundColor: heavyStyle ? errorBackground : "" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key={message}
      ref={errorRef}
    >
      <div className="flex">
        <div className="mx-1">
          <div
            className="text-base"
            style={{
              color: heavyStyle ? "white" : errorBackground,
            }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Error;
